import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const PlantMasterPopup = (props) => {
    return (
        <ModalBasic
            id="plantMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Plant master</span>
                <div className='item-grp grid grid-cols-1 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Plant name</label>
                        <TextInput type='text'
                            id='plantName' name='plantName'
                            value={props.plantObject.plantName}
                            handleChange={(event) => props.handleChange(event, 'plantName')}
                            className={props.validState?.error?.plantName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Plant description</label>
                        <TextInput type='text'
                            id='plantDesc' name='plantDesc'
                            value={props.plantObject.plantDesc}
                            handleChange={(event) => props.handleChange(event, 'plantDesc')}
                            // className={props.validState?.error?.plantDesc !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.plantObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label className='flex items-center gap-[5px]'>
                            <TextInput type='checkbox'
                                id='allow' name='allow'
                                //value={props.plantObject.allow}
                                handleChange={(event) => props.handleChange(event, 'allow')}
                                className="w-[15px] h-[15px]"
                                checked={props.plantObject.allow}
                            />
                            Allow for dashboard production data
                        </label>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}